import { ConsultationReport } from "~/providers/components";

export const LeadPatientConsultationReport = () => {
  return <ConsultationReport />;
};
